import { SportEventV2, SportType } from '@/@types/graphql-types';
import type { ComputedRef, InjectionKey } from 'vue';
import { Provider } from '@/features/sports/types/provider-streams-comparator-types';

export type TimeGroup = 'live' | 'today' | 'upcoming' | 'past';
export type FilteredEvents = Record<TimeGroup, Array<SportEventV2>>;
export const SPORT_PROVIDERS_BY_SHORT_NAME_KEY = Symbol('sportProvidersByShortName') as InjectionKey<
	ComputedRef<Provider[]>
>;

export const HomepageSports: SportType[] = [
	SportType.Football,
	SportType.AmericanFootball,
	SportType.Tennis,
	SportType.Baseball,
	SportType.Basketball,
	SportType.IceHockey,
];
